var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1354 5.78125H8.86458C7.16171 5.78125 5.78125 7.16171 5.78125 8.86458V28.1354C5.78125 29.8383 7.16171 31.2188 8.86458 31.2188H28.1354C29.8383 31.2188 31.2188 29.8383 31.2188 28.1354V8.86458C31.2188 7.16171 29.8383 5.78125 28.1354 5.78125Z",
    stroke: "#3E3E3E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 16.5732V25.0524",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 13.8749C13.5702 13.8749 14.2605 13.1847 14.2605 12.3332C14.2605 11.4818 13.5702 10.7915 12.7188 10.7915C11.8674 10.7915 11.1771 11.4818 11.1771 12.3332C11.1771 13.1847 11.8674 13.8749 12.7188 13.8749Z",
    fill: "#3E3E3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2812 25.0524V20.0419C24.2812 18.1262 22.7282 16.5732 20.8125 16.5732C18.8968 16.5732 17.3438 18.1262 17.3438 20.0419V25.0524",
    stroke: "#3E3E3E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.135153940ca0b9b4b46e4dce4be14665.svg";
export { ForwardRef as ReactComponent };